var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
/**
 * @hidden
 */
export var ShowMoreItemsButton = React.forwardRef(function (props, ref) {
    var btn = React.useRef(null);
    var element = React.useRef(null);
    React.useImperativeHandle(btn, function () { return (__assign({ element: element.current }, props)); });
    React.useImperativeHandle(ref, function () { return btn.current; });
    var handleClick = React.useCallback(function (syntheticEvent) {
        if (!props.onClick || !btn.current) {
            return;
        }
        props.onClick.call(undefined, {
            target: btn.current,
            syntheticEvent: syntheticEvent
        });
    }, [
        btn,
        props.slot,
        props.onClick
    ]);
    return (React.createElement("button", { ref: element, tabIndex: -1, className: "k-more-events k-button", onClick: handleClick },
        React.createElement("span", { className: "k-icon k-i-more-horizontal" })));
});
//# sourceMappingURL=ShowMoreItemsButton.js.map